import React from "react";
import "./hashtag.css";
export default function Hashtag() {
  return (
    <div>
      <div>Hashtag</div>
    </div>
  );
}
